import {
  Typography,
  Paper,
  Grid,
  Select,
  MenuItem,
  Button,
  FormControl,
  InputLabel,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import ApiService from '../../functions/apiService';
import moment from 'moment';
import { toast } from 'react-toastify';
import { useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';

export const RotationTableModal = ({
  employeeInfo,
  toggleModal,
  shiftsInfo,
	getRotationData,
	editData
}) => {
  const [emp, setEmp] = useState(null);
  const absentReasons = useSelector(
    (state) => state.dashboardReducer.AbsentReasonAll
  );
  const [params] = useSearchParams();
  const date = moment(params.get('date') || new Date());

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isDirty, isValid },
		trigger,
  } = useForm({
    defaultValues: {
      shift: '',
      ptoType: '',
    },
    mode: 'onChange',
  });

  useEffect(() => {
    const getEmployee = async () => {
      try {
        const data = await ApiService.post('/getEmployees', {
          EmpIds: [employeeInfo],
          date: date.format('YYYY-MM-DD'),
        });

        setEmp(data[0]);
      } catch (error) {
        console.error(error);
      }
    };

    getEmployee();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

	useEffect(() => {
		setValue('shift', editData.shift_Code[0], {
			shouldValidate: true,
			shouldDirty: true,
		});
	}, [editData, setValue]);


  const onSubmit = async (formData) => {
    try {
			if(editData.shift_Code[0] !== formData.shift){
				toast.error("Please choose same shift")
			}
			else{
				const selectedShift = shiftsInfo.find(
        (s) => Number(s.shiftCode) === Number(formData.shift)
				);

				const requestData = {
					EmpCode: employeeInfo,
					RequestDate: date.format('YYYY-MM-DD'),
					// ShiftCode: formData.shift,
					ShiftCode: parseInt(formData.shift, 10),
					SelAbsent: formData.ptoType,
					SelEmp: '',
					EndTime: selectedShift ? selectedShift.endTime : '',
					StartTime: selectedShift ? selectedShift.startTime : '',
				};

				await ApiService.post('/postAdminAddOvertime', { ...requestData });

				toast.success('Successfully saved!', { position: 'top-right' });
				toggleModal();
				getRotationData();
			}
    } catch (error) {
      console.error('Error saving time off:', error);
      toast.error('Failed to save time off', { position: 'top-right' });
    }
  };

  return (
    <>
      <Button sx={{ mb: 2 }} size="small" color="inherit" onClick={toggleModal}>
        ← Back
      </Button>

      <Typography variant="h6" fontWeight={700} gutterBottom>
        {date.format('dddd Do MMMM YYYY')}
      </Typography>

      <Paper
        variant="outlined"
        sx={{ p: 2, my: 2, borderColor: '#e0e0e0', backgroundColor: '#fafafa' }}
      >
        <Typography color="error" fontWeight={700}>
          Selected Members
        </Typography>
        <Typography>
          {emp ? `${emp.employee_assignment.EA_Rank} ${emp.fullName}` : ''}
        </Typography>
      </Paper>

      <Typography variant="subtitle1" fontWeight={600} gutterBottom>
        Add Time Off
      </Typography>

      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth error={!!errors.shift}>
              <InputLabel>Shift</InputLabel>
              <Select
                label="Shift"
                {...register('shift', {
                  required: 'Shift is required',
                })}
                onChange={(e) =>
                  setValue('shift', e.target.value, {
                    shouldValidate: true,
                    shouldDirty: true,
                  })
                }
								defaultValue={editData?.shift_Code[0]}
              >
                {shiftsInfo &&
                  shiftsInfo.map((shift) => (
                    <MenuItem key={shift.shiftCode} value={shift.shiftCode}>
                      {shift.title}
                    </MenuItem>
                  ))}
              </Select>
              {errors.shift && (
                <Typography
                  variant="caption"
                  color="error"
                  sx={{ mt: 0.5, display: 'block' }}
                >
                  {errors.shift.message}
                </Typography>
              )}
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControl fullWidth error={!!errors.ptoType}>
              <InputLabel>PTO Type</InputLabel>
              <Select
                label="PTO Type"
                {...register('ptoType', {
                  required: 'PTO Type is required',
                })}
                onChange={(e) =>
                  setValue('ptoType', e.target.value, {
                    shouldValidate: true,
                    shouldDirty: true,
                  })
                }
              >
                {Object.entries(absentReasons).map(([key, value]) => (
                  <MenuItem key={key} value={key}>
                    {value}
                  </MenuItem>
                ))}
              </Select>
              {errors.ptoType && (
                <Typography
                  variant="caption"
                  color="error"
                  sx={{ mt: 0.5, display: 'block' }}
                >
                  {errors.ptoType.message}
                </Typography>
              )}
            </FormControl>
          </Grid>
        </Grid>

        <ButtonTheme
          type="submit"
					color="primary"
					className = "mt-3"
          disabled={!isDirty || !isValid || !editData.shift_Code}
        >
          Save
        </ButtonTheme>
      </form>
    </>
  );
};
